import { ElementController, getData, selectSingle } from 'js-common';

import { MONTHLY_DONOR_FORM_CONTROLLER_ID } from './constants';
import { setHidden } from './utils';

/**
 * Controller for monthly donation registration form.
 */
export default class MonthlyDonorForm extends ElementController {
  static id = MONTHLY_DONOR_FORM_CONTROLLER_ID;

  /**
   * DOM ready.
   */
  init() {
    this.monthlyAmount = this.selectSingle('monthly-amount');
    this.monthlyAmountSelect = selectSingle(this.monthlyAmount, 'select');
    this.monthlyAmountCustomValue = getData(
      this.monthlyAmount,
      'custom-amount-value',
    );
    this.customMonthlyAmount = this.selectSingle('custom-monthly-amount');
    this.customMonthlyAmountInput = selectSingle(
      this.customMonthlyAmount,
      'input',
    );
    this.taxReduction = this.selectSingle('tax-reduction');
    this.minTaxReductionAmount = getData(this.taxReduction, 'min-amount');

    this.toggleFieldVisibility();

    this.on(this.monthlyAmountSelect, 'change', this.handleMonthlyAmountChange);
    this.on(
      this.customMonthlyAmountInput,
      'input',
      this.handleCustomMonthlyAmountInput,
    );
  }

  /**
   * The monthly amount select value.
   *
   * @returns {number|string} - Parsed if not set to custom
   */
  get monthlyAmountValue() {
    const val = this.monthlyAmountSelect.value;
    return val === this.monthlyAmountCustomValue ? val : parseInt(val, 10);
  }

  /**
   * The custom monthly amount input value.
   *
   * @returns {number}
   */
  get customMonthlyAmountValue() {
    // Will be NaN if empty
    return parseInt(this.customMonthlyAmountInput.value, 10) || 0;
  }

  /**
   * If the monthly amount select is set to custom.
   *
   * @returns {boolean}
   */
  get isCustomMonthlyAmount() {
    return this.monthlyAmountValue === this.monthlyAmountCustomValue;
  }

  /**
   * Toggle field visibility depending on monthly donation amount.
   */
  toggleFieldVisibility() {
    const isCustom = this.isCustomMonthlyAmount;
    const monthlyVal = isCustom
      ? this.customMonthlyAmountValue
      : this.monthlyAmountValue;

    setHidden(this.customMonthlyAmount, !isCustom);
    setHidden(this.taxReduction, monthlyVal < this.minTaxReductionAmount);
  }

  /**
   * Monthly amount select list.
   */
  handleMonthlyAmountChange = () => {
    this.toggleFieldVisibility();
  };

  /**
   * Custom monthly amount input field.
   */
  handleCustomMonthlyAmountInput = () => {
    this.toggleFieldVisibility();
  };
}
